module.exports = __webpack_public_path__ + "static/media/WEB23.b346d6c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB23.jpg
// module id = 93
// module chunks = 0